<template>
    <div class="navi">
        <router-link :to='getLinkTarget("PSGRequestAccept", "/philips/psg/PSGRequestAccept")'>
            <div :class='getClass("PSGRequestAccept")'><b-icon icon="stamper"/>受付</div>
        </router-link>
        <router-link :to='getLinkTarget("PSGAnalyisisResult", "/philips/psg/PSGAnalyisisResult")'>
            <div :class='getClass("PSGAnalyisisResult")'><b-icon icon="clipboard-pulse-outline"/>解析結果入力</div>
        </router-link>
        <router-link :to='getLinkTarget("PSGApproval", "/philips/psg/PSGApproval")'>
            <div :class='getClass("PSGApproval")'><b-icon icon="map-check-outline"/>結果承認</div>
        </router-link>
    </div>
</template>

<script>
export default {
  name: "PSGNaviBar",
  props: ["pageid"],
  methods: {
      getLinkTarget: function(tabkind, target){
          var ret = target;
          if(tabkind == this.pageid){
              ret = ""
          }
          return ret;
      },
      getClass: function(tabkind) {
          var ret = "tabLabel ";
          if(tabkind == this.pageid){
            ret += "active";
          } else {
            ret += "deactive";
          }
          return ret;
      }

  },
  data() {
    return {
    };
  },
  filters: {},
  components: {},

};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
    height: 20px;
    margin-top:-20px;
}
.tabLabel {
    float:left;
    text-align: center; 
    border-radius: 10px 10px 0px 0px;
    border-width:1px;
	border-top-style: solid;
	border-right-style: solid;
	border-left-style: solid;
    width: 150px;
    height: 30px;
}
.tabLabel.active {
    color: white;
	border-color: #000894;
    background-color: #000894;
}
.tabLabel.deactive {
	border-color: #f7f7f7;
    background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/psg/PSGNaviBar.vue